import { GET, POST } from "./common/http";
import { BASE_URL } from "./common/const";

export const GetCountryRegionList = (params: any) =>
  GET(`${BASE_URL}/api/CountryRegion/GetList?` + params, null);

  export const GetCountryRegionListForSelect = (params: any) =>
  GET(`${BASE_URL}/api/CountryRegion/GetListForSelect?` + params, null);